"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _querystring = _interopRequireDefault(require("querystring"));

var _FeaturedList = _interopRequireDefault(require("./FeaturedList"));

var _ViewPostModal = _interopRequireDefault(require("../../../../../common/components/ViewPostModal"));

var _AvailableLibrarySelector = _interopRequireDefault(require("../../../../../common/components/AvailableLibrarySelector"));

var _SearchPostsList = _interopRequireDefault(require("./SearchPostsList"));

var _RecentPostsList = _interopRequireDefault(require("./RecentPostsList"));

var _ActiveCampaigns = _interopRequireDefault(require("./ActiveCampaigns"));

var _withPostList = _interopRequireDefault(require("./withPostList"));

var _ReportPostModal = _interopRequireDefault(require("../../../../../common/components/ReportPostModal"));

require("../styles/_home-body.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SearchPostsListComponent = (0, _withPostList.default)(_SearchPostsList.default);
var RecentPostsListComponent = (0, _withPostList.default)(_RecentPostsList.default);

var HomeBody = /*#__PURE__*/function (_Component) {
  _inherits(HomeBody, _Component);

  function HomeBody(props) {
    var _this;

    _classCallCheck(this, HomeBody);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HomeBody).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "changeQueryParam", (0, _lodash.default)(function (_ref) {
      var key = _ref.key,
          value = _ref.value;
      return function () {
        _this.updateQueryParams({
          key: key,
          value: value
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onNavigationCarouselClick", (0, _lodash.default)(function (key) {
      return function (value) {
        _this.updateQueryParams({
          key: key,
          value: value
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "openReportModal", (0, _lodash.default)(function (modalPostId) {
      return function () {
        _this.setState({
          reportModalOpened: true,
          modalPostId: modalPostId
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "updateQueryParams", function (_ref2) {
      var key = _ref2.key,
          value = _ref2.value;
      var _this$props = _this.props,
          history = _this$props.history,
          location = _this$props.history.location,
          queryParams = _this$props.queryParams;

      var updatedQueryParams = _objectSpread({}, queryParams, _defineProperty({}, key, value));

      var search = _querystring.default.stringify(updatedQueryParams);

      history.rootPush("".concat(location.pathname, "?").concat(search));
    });

    _defineProperty(_assertThisInitialized(_this), "closeReportModal", function () {
      _this.setState({
        reportModalOpened: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openViewPostModal", function (post) {
      _this.setState({
        modalPostId: post.inspirationId,
        viewModalOpened: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modalPostId: void 0,
        viewModalOpened: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInspirationFavourited", function (_ref3) {
      var inspirationId = _ref3.inspirationId,
          isFavourited = _ref3.isFavourited;

      _this.setState({
        latestFavouriteUpdate: {
          inspirationId: inspirationId,
          isFavourited: isFavourited
        }
      });
    });

    var hash = props.location.hash;

    var _inspirationId = hash ? hash.substring(1) : void 0;

    _this.state = {
      modalPostId: _inspirationId,
      latestFavouriteUpdate: {},
      reportModalOpened: false,
      viewModalOpened: Boolean(_inspirationId)
    };
    return _this;
  }

  _createClass(HomeBody, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          searchFilters = _this$props2.searchFilters,
          history = _this$props2.history,
          getInspirations = _this$props2.getInspirations,
          fetchAssets = _this$props2.fetchAssets,
          organisationMemberships = _this$props2.organisationMemberships,
          setSelectedOrgId = _this$props2.setSelectedOrgId,
          selectedInspirationOrgId = _this$props2.selectedInspirationOrgId,
          toggleInspirationFavourite = _this$props2.toggleInspirationFavourite;
      var _this$state = this.state,
          modalPostId = _this$state.modalPostId,
          latestFavouriteUpdate = _this$state.latestFavouriteUpdate,
          reportModalOpened = _this$state.reportModalOpened,
          viewModalOpened = _this$state.viewModalOpened;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_AvailableLibrarySelector.default, {
        organisationMemberships: organisationMemberships,
        setSelectedOrgId: setSelectedOrgId,
        selectedInspirationOrgId: selectedInspirationOrgId
      }), _react.default.createElement("div", {
        className: "home-body column"
      }, modalPostId && _react.default.createElement(_ReportPostModal.default, {
        key: modalPostId,
        onClose: this.closeReportModal,
        visible: Boolean(modalPostId && reportModalOpened),
        inspirationId: modalPostId
      }), modalPostId && viewModalOpened && _react.default.createElement(_ViewPostModal.default, {
        onClose: this.closeModal,
        isVisible: Boolean(modalPostId && viewModalOpened && !reportModalOpened),
        inspirationId: modalPostId,
        openReportModal: this.openReportModal(modalPostId)
      }), !searchFilters ? _react.default.createElement("div", {
        className: "home-body__content"
      }, _react.default.createElement(_ActiveCampaigns.default, {
        openViewPostModal: this.openViewPostModal,
        fetchAssets: fetchAssets,
        history: history
      }), _react.default.createElement(_FeaturedList.default, {
        openViewPostModal: this.openViewPostModal,
        getInspirations: getInspirations,
        fetchAssets: fetchAssets,
        history: history,
        selectedInspirationOrgId: selectedInspirationOrgId,
        toggleInspirationFavourite: toggleInspirationFavourite,
        latestFavouriteUpdate: latestFavouriteUpdate,
        onInspirationFavourited: this.handleInspirationFavourited,
        openReportModal: this.openReportModal
      }), _react.default.createElement(RecentPostsListComponent, {
        history: history,
        openViewPostModal: this.openViewPostModal,
        getInspirations: getInspirations,
        fetchAssets: fetchAssets,
        selectedInspirationOrgId: selectedInspirationOrgId,
        toggleInspirationFavourite: toggleInspirationFavourite,
        openReportModal: this.openReportModal,
        latestFavouriteUpdate: latestFavouriteUpdate,
        onInspirationFavourited: this.handleInspirationFavourited
      })) : _react.default.createElement(SearchPostsListComponent, {
        history: history,
        filters: searchFilters,
        getInspirations: getInspirations,
        fetchAssets: fetchAssets,
        openViewPostModal: this.openViewPostModal,
        selectedInspirationOrgId: selectedInspirationOrgId,
        toggleInspirationFavourite: toggleInspirationFavourite,
        openReportModal: this.openReportModal,
        latestFavouriteUpdate: latestFavouriteUpdate,
        onInspirationFavourited: this.handleInspirationFavourited
      })));
    }
  }]);

  return HomeBody;
}(_react.Component);

exports.default = HomeBody;